import React from 'react';
import ScoreItem from '../ScoreItem';
import {ProspectPool, ProspectPoolScore, ProspectScoreCustomizeItem} from 'api';

interface CustomScoreItemsProps {
  prospectPool: ProspectPool;
  prospectScore: ProspectPoolScore;
  settingItem: ProspectScoreCustomizeItem;
}

const CustomScoreItems: React.FC<CustomScoreItemsProps> = ({
  prospectPool,
  prospectScore,
  settingItem,
}) => {
  const customizeItem = settingItem?.poolProspectCustomizeItem;
  const customizeItemId = customizeItem?.id;

  const customizeItemScore =
    prospectScore?.prospectPoolCustomizeItemScores?.find(
      (score) => score?.poolProspectCustomizeItem?.id === customizeItemId,
    );

  const customizeItemSelect =
    prospectPool?.prospect?.customizeItemSelects?.find(
      (item) => item.poolProspectCustomizeItemId === customizeItemId,
    );

  const hasSelectOptions =
    (customizeItemSelect?.prospectCustomizeItemSelectOptions?.length ?? 0) > 0;
  const target = settingItem?.weight !== 0 && hasSelectOptions;

  const hasSetting =
    (settingItem?.clientProspectScoreSettingCustomizeItemSelectOptions
      ?.length ?? 0) > 0;

  return (
    <ScoreItem
      key={customizeItemId}
      title={customizeItem?.name}
      score={Math.round((customizeItemScore?.score || 0) * 0.6)}
      target={target}
      hasSetting={hasSetting}
    />
  );
};

export default CustomScoreItems;
